import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const getMyProfile = () => {
    return handler.get(`users/me`);
};
const getUser = (userId) => {
    return handler.get(`users/${userId}`);
};
const getUsers = (customerId, page, pageSize) => {
    return handler.get(`users/list/${customerId}?page=${page}&pageSize=${pageSize}`);
};
const getUserDrones = (userId, page, pageSize) => {
    return handler.get(`users/${userId}/drones?page=${page}&pageSize=${pageSize}`);
};
const blockUser = (userId) => {
    return handler.put(`users/block/${userId}`);
};
const makeAdmin = (userId) => {
    return handler.post(`users/make-admin/${userId}`);
};
const revokeAdmin = (userId) => {
    return handler.post(`users/revoke-admin/${userId}`);
};
const assignUserDrone = (userId, droneId) => {
    return handler.put(`users/${userId}/assign/${droneId}`);
};
const unAssignUserDrone = (userId, droneId) => {
    return handler.put(`users/${userId}/unassign/${droneId}`);
};
const updateUserEmail = (email, password) => {
    return handler.put(`users/change-email/`, {
        email,
        password
    });
};
const verifyEmailCode = (email, code) => {
    return handler.put(`users/verify-email-code/`, {
        code,
        email
    });
};
const verifyEmailToken = (userId, email, token) => {
    return handler.put(`users/verify-email-token/`, {
        userId,
        token,
        email
    });
};
export default {
    getMyProfile,
    getUser,
    getUsers,
    getUserDrones,
    blockUser,
    makeAdmin,
    revokeAdmin,
    assignUserDrone,
    unAssignUserDrone,
    updateUserEmail,
    verifyEmailCode,
    verifyEmailToken
};
